<template>
  <div class='mainContainer' v-loading='importLoading'>
    <div class='nav'>
      <div class='navContainer' style='width: 230px'>
        <p>批次号：</p>
        <el-input v-model='condition.batchNumber' size='mini' style='width:150px'
                  placeholder='请输入批次号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>运单编号：</p>
        <el-input v-model='condition.waybillNo' size='mini' style='width:150px'
                  placeholder='请输入运单编号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>车架号：</p>
        <el-input v-model='condition.frameNumber' size='mini' style='width:150px'
                  placeholder='请输入车架号'
                  @paste.native.capture.prevent="(value)=>{ return searchCopyFormat(value,'frameNumber')}"
        />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>品牌：</p>
        <el-input v-model='condition.brandName' size='mini' style='width:150px'
                  placeholder='请输入品牌' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>型号：</p>
        <el-input v-model='condition.modelName' size='mini' style='width:150px'
                  placeholder='请输入型号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>司机姓名：</p>
        <el-input v-model='condition.taskToolName' size='mini' style='width:150px'
                  placeholder='请输入司机姓名' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>车牌号：</p>
        <el-input v-model='condition.taskToolNum' size='mini' style='width:150px'
                  placeholder='请输入车牌号' />
      </div>
      <div class='navContainer' style='width: 230px'>
        <p>扫码人：</p>
        <el-input v-model='condition.taskPeople' size='mini' style='width:150px'
                  placeholder='请输入扫码人' />
      </div>
      <div class='navContainer' style='width: 400px'>
        <p>扫码时间：</p>
        <el-date-picker v-model='condition.startTime' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd' @change='dateChange' type='date'
                        placeholder='开始日期' />
        <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
        <el-date-picker v-model='condition.endTime' size='mini' style='width:150px'
                        value-format='yyyy-MM-dd' @change='dateChange' type='date'
                        placeholder='结束日期' />
      </div>
      <div class='navBtn'>
        <el-button size='small' class='searchBtn' @click='searchBtn'>查询</el-button>
        <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        <!-- <el-button size="small" type="primary" @click="addBtn">手动装车</el-button> -->
      </div>
    </div>
    <div class='content'>
      <div class='tableContainer'>
        <div class='tableContainerNav'>
          <span @click='downLoad'>下载模板</span>
          <span style='cursor: pointer'>
            <el-upload
              ref='upload'
              class='upload-demo'
              :action='uploadUrl'
              :auto-upload='true'
              :show-file-list='false'
              :data='uploadData'
              :on-success='planOnSuccess'
              :before-upload='beforeUpload'
            >
              <i class='el-icon-upload el-icon--right'>批量导入</i>
            </el-upload>
          </span>
          <span @click='exportClick'>导出数据</span>
        </div>
        <el-table
          v-loading='tableLoad'
          :data='TableDatas'
          style='width: 100%'
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label='序号' align='center' width='50px'>
            <div slot-scope='scope'>{{ scope.$index + 1 }}</div>
          </el-table-column>
          <el-table-column prop='batchNumber' label='批次号' align='center' />
          <el-table-column prop='waybillNo' label='运单号' align='center' />
          <el-table-column prop='frameNumber' label='车架号' align='center' />
          <el-table-column prop='brandName' label='品牌' align='center' />
          <el-table-column prop='modelName' label='型号' align='center' />
          <el-table-column prop='taskToolName' label='司机姓名' align='center' />
          <el-table-column prop='taskToolNum' label='车牌号' align='center' />
          <!-- <el-table-column prop="type" label="作业类别" align="center">
            <div slot-scope="scope">{{getType(scope.row.type)}}</div>
          </el-table-column> -->
          <el-table-column prop='taskPeople' label='扫码人' align='center' />
          <el-table-column prop='taskDate' label='扫码时间' align='center' />
          <el-table-column prop='taskPositionName' label='扫码地址' align='center' />
          <!-- <el-table-column label="操作" width="100" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button size="mini" type="danger" @click="failureClick(scope.row.id)">装车失败</el-button>
 &lt;!&ndash;                <div v-else style="width:100%;display:flex;align-items:center;justify-content:center">-</div>&ndash;&gt;
              </div>
            </template>
          </el-table-column> -->
        </el-table>
      </div>
      <div class='paginationContainer'>
        <span>共{{ total }}条</span>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='sizes,prev, pager, next,jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          @prev-click='contractCurrentChange'
          @next-click='contractCurrentChange'
        />
      </div>
    </div>
    <el-dialog title='手动装车' :visible.sync='dialogVisible' width='800px' center
               :close-on-click-modal='false'>
      <div class='company'>
        <el-form :model='teamData' label-width='100px' :rules='rules' ref='ruleForm'>
          <div class='transport'>
            <div-border label='基础信息'>
              <!-- <el-form-item label="装车地类型：" style="margin-top: 10px;" prop="type">
                <el-radio-group v-model="teamData.type" @change="positionChange(teamData.type)" size="mini">
                  <el-radio :label="1">委托商</el-radio>
                  <el-radio :label="2">港口</el-radio>
                  <el-radio :label="3">经销商</el-radio>

                </el-radio-group>
              </el-form-item> -->
              <el-row>
                <el-col :span='13'>
                  <el-form-item label='选择装车地：' prop='position'>
                    <!-- <el-select v-if="teamData.type !==1" v-model="teamData.position" size="mini"  style="width:85%" placeholder="请选择装车地" value-key="id" @change="carChange2">
                      <el-option v-for="item in positionOption" :key="item.id" :label="teamData.type !==3?item.supplier_name:item.shorter_name" :value="item"/>
                    </el-select> -->
                    <!-- v-if="teamData.type===1" -->
                    <el-cascader
                      filterable
                      size='mini'
                      style='width:100%'
                      v-model='teamData.position'
                      placeholder='请选择装车地'
                      :options='positionOption'
                      :props='props'
                      clearable
                      @change='handleChange' />
                  </el-form-item>
                </el-col>
                <el-col :span='9'>
                  <el-form-item label='装车港口：' prop='startPort'>
                    <el-select v-model='teamData.startPort' filterable size='mini'
                               style='width:100%' clearable placeholder='请选择装车港口'
                               @change='portChange'>
                      <el-option v-for='item in startPortList' :key='item.id'
                                 :label='item.supplier_name' :value='item.id'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span='13'>
                  <el-form-item label='选择供应商：' prop='entrust' style='margin-top: 10px'>
                    <el-select v-model='teamData.entrust' filterable size='mini' style='width:100%'
                               placeholder='请选择供应商' value-key='fleet_id' @change='carChange'>
                      <el-option v-for='item in entrustOption' :key='item.fleetId'
                                 :label='item.fleet_name' :value='item.fleet_id' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span='9'>
                  <el-form-item label='选择交车地：' prop='task' style='margin-top: 10px'>
                    <el-select v-model='teamData.task' filterable size='mini' style='width:100%'
                               clearable placeholder='请选择交车地' @change='taskChange'>
                      <el-option v-for='item in taskList' :key='item.id' :label='item.delivery_name'
                                 :value='item'></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span='22' v-if='teamData.task'>
                  <div class='form-item-span'>
                    <span>委托数量：{{ teamData.task.fleet_count }}</span>
                    <span>剩余托运数量：{{ teamData.task.surplus_count }}</span>
                  </div>
                  <div class='form-item-span'>
                    <span>装车时间：{{ teamData.task.entruck_time }}</span>
                  </div>
                </el-col>
                <el-col :span='22'>
                  <el-form-item label='选择运输车：' prop='shippers' style='margin-bottom: 15px;'>
                    <el-select v-model='teamData.shippers' filterable size='mini' style='width:100%'
                               placeholder='请选择运输车' @change='entrustChange' value-key='id'>
                      <el-option v-for='item in shippersOption' :key='item.id'
                                 :label='item.truck_name' :value='item' />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span='22'>
                  <div :style="`opacity: ${teamData.shippers?'1':'0'}`"
                       style='display:flex;align-items:center;justify-content:space-between;width:80%;margin-left: 10%;margin-bottom: 10px;'
                       v-if='teamData.shippers'>
                    <span
                      style='color: #606266;font-weight: 700'>司机姓名：{{ teamData.shippers.driver_name
                      }}</span>
                    <span
                      style='color: #606266;font-weight: 700'>司机电话：{{ teamData.shippers.driver_tel
                      }}</span>
                  </div>
                </el-col>
              </el-row>
            </div-border>
            <div-border label='选择委托车'>
              <!-- <el-table
                :data="teamData.table"
                style="width: 100%;margin-top: 10px;"
                height="200"
                border
                @selection-change="handleSelectionChange"
                ref="entrustTableRef"
              >
                <el-table-column type="selection" width="34" />
                <el-table-column prop="batch_number" label="批次号" align="center"/>
                <el-table-column prop="bill_number" label="运单号" width="150" align="center"/>
                <el-table-column prop="frame_number" label="车架号" width="150" align="center"/>
                <el-table-column prop="brand" label="品牌" align="center"/>
                <el-table-column prop="model" label="型号" align="center"/>
                <el-table-column prop="color" label="颜色" align="center"/>
                <el-table-column prop="file_name" label="附件" width="50" align="center"/>
              </el-table> -->
              <div class='nav'>
                <div class='navContainer' style='width: 200px'>
                  <p style='width:60px;display:inline-block;text-align:right'>批次号：</p>
                  <el-input v-model='entrustedTable.batchNumber' size='mini' style='width:130px'
                            placeholder='请输入批次号' />
                </div>
                <div class='navContainer' style='width: 200px'>
                  <p style='width:60px;display:inline-block;text-align:right'>运单号：</p>
                  <el-input v-model='entrustedTable.waybillNo' size='mini' style='width:130px'
                            placeholder='请输入运单号' />
                </div>
                <div class='navBtn'>
                  <el-button size='small' class='searchBtn' @click='carSearchBtn'>查询</el-button>
                  <el-button size='small' class='resetBtn' @click='carResetBtn'>重置</el-button>
                </div>
              </div>
              <el-table
                :data='teamData.table'
                v-loading='carTableLoad'
                style='width: 100%' border stripe
                @expand-change='expandChange'
                :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'30px',background:'#E8E8E8'}"
                :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'30px'}">
                <el-table-column type='expand' width='30'>
                  <template slot-scope='scopeOut'>
                    <div style='width: 95%;margin-left: auto;' v-loading='scopeOut.row.loading'>
                      <el-table
                        :data='scopeOut.row.children'
                        border
                        max-height='300'
                        style='width: 100%'
                        :ref='scopeOut.row.batch_number+scopeOut.row.waybill_no'
                        @selection-change='handleCurrentChange($event,scopeOut.$index)'
                        :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'30px',background:'#E8E8E8'}"
                        :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'30px',}">
                        <el-table-column type='selection' align='center' width='50px' />
                        <el-table-column prop='frame_number' label='车架号' min-width='130'
                                         align='center'>
                          <template slot-scope='scope'>
                            <span v-if='scope.row.state==1'
                                  class='require'>{{ scope.row.frame_number }}</span>
                            <span v-else>{{ scope.row.frame_number }}</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop='brand_name' label='品牌' min-width='100'
                                         align='center' />
                        <el-table-column prop='model_name' label='型号' min-width='100'
                                         align='center' />
                        <el-table-column prop='weight' label='重量' align='center' />
                        <el-table-column prop='departure_port' label='交车港口' align='center' />
                      </el-table>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop='batch_number' label='批次号' align='center'>
                  <template slot-scope='scope'>
                    <span v-if='scope.row.state==1'
                          class='require'>{{ scope.row.batch_number }}</span>
                    <span v-else>{{ scope.row.batch_number }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop='waybill_no' label='运单号' align='center' />
                <el-table-column prop='count_car' label='数量' align='center' />
              </el-table>
              <div class='paginationContainer' style='margin: 10px 0px;'>
                <span>共{{ entrustedTable.total }}条</span>
                <el-pagination
                  background
                  :page-size='10'
                  layout='prev, pager, next,jumper'
                  :total='entrustedTable.total'
                  @size-change='conditionSizeChange'
                  @current-change='conditionCurrentChange'
                  @prev-click='conditionCurrentChange'
                  @next-click='conditionCurrentChange'
                />
              </div>
            </div-border>
          </div>
        </el-form>
        <div class='btnContainer'>
          <el-button class='searchBtn' :loading='teamDataLoad' @click='saveClick' size='small'>确定
          </el-button>
          <el-button class='resetBtn' @click='dialogClose' size='small'>取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import divBorder from '@/components/divBorder';
  import {
    getTruckCarBySupplier, getInfoByDriverId, getSelectPort, supplierPublicSelectDistributor,
    vehicleGetSupplierByAppointPosition, vehiclAddScanOperation, entruckInfoCvPageList, cancel,
    selectCarByPosition, vehiclePublicSelectWarehouse, supplierPublicSelectPort,
    loadingPageList, loadingChildPageList,
  } from '@/service/vehiclelog';
  import { baseUrl } from '@/config/env';
  import { getSessionStore } from '@/config/mUtils';
  import { getImport, getImportUrl } from '@/service/getIP';

  export default {
    components: {
      divBorder,
    },
    data() {
      let dateItem = new Date(new Date().getTime() - 144 * 60 * 60 * 1000);	//使用当天时间戳减去以前的时间毫秒（小时*分*秒*毫秒）
      let startDay = dateItem.getFullYear() + '-' +
        (dateItem.getMonth() + 1).toString()
          .padStart(2, '0') + '-' +
        dateItem.getDate()
          .toString()
          .padStart(2, '0');
      let endDay = new Date().getFullYear() + '-' +
        (new Date().getMonth() + 1).toString()
          .padStart(2, '0') + '-' +
        new Date().getDate()
          .toString()
          .padStart(2, '0');
      return {
        // 查询条件
        importLoading: false,
        condition: {
          batchNumber: '',   // 批次号
          waybillNo: '',    // 运单号
          frameNumber: '',    // 车架号
          brandName: '',    // 品牌
          modelName: '',    // 型号
          taskToolName: '',   // 司机姓名
          taskToolNum: '',    // 车牌号
          taskPeople: '',   // 扫码人
          // time: '',   // 开始/结束时间
          startTime: startDay,
          endTime: endDay,
        },
        positionOption: [],
        props: {
          value: 'id',
          label: 'cityName',
          children: 'children',
          checkStrictly: true,
        },
        consignorMap: new Map(),
        timeIpt: '',
        page: 1,
        size: 10,
        total: 0,
        tableLoad: false,
        TableDatas: [],
        uploadUrl: '',//导入地址
        uploadData: {
          file: '',
        },
        entrustOption: [],
        shippersOption: [],
        teamData: {},
        startPortList: [],  // 装车港口
        taskList: [],  // 选择交车地
        teamDataLoad: false,
        rules: {
          entrust: [
            {
              required: true,
              message: '请选择供应商',
              trigger: 'change',
            },
          ],
          type: [
            {
              required: true,
              message: '请选择装车地类型',
              trigger: 'change',
            },
          ],
          task: [
            {
              required: true,
              message: '请选择交车地',
              trigger: 'change',
            },
          ],
          position: [
            {
              required: true,
              message: '请选择装车地',
              trigger: 'blur',
            },
          ],
          shippers: [
            {
              required: true,
              message: '请选择运输车',
              trigger: 'change',
            },
          ],
          startPort: [{
            required: false,
            message: '请选择装车港口',
            trigger: 'change',
          }],
        },
        dialogVisible: false,
        entrustedTable: {   // 装车车辆 查询条件
          batchNumber: '',
          waybillNo: '',
          page: 1,
          size: 10,
          total: 0,
        },
        carTableLoad: false,   // 装车车辆 加载中
        selectData: [],  //装车车辆 —— 批次号 选中数据
      };
    },
    computed: {
      getType() {
        return function(type) {
          switch (type) {
            case 1:
              return '扫码';
            case 2:
              return '批量导入';
            case 3:
              return '手动装车';
          }
        };
      },
    },
    mounted() {
      this.init();
      this.positionOption = JSON.parse(sessionStorage.getItem('areaList'));
      this.uploadUrl = getImportUrl('/transportScanOperation/importExcelxlAddDriverIn');
    },
    methods: {
      async init() {
       // await this._vehicleDeployCarCvPageList();

      },
      async _vehicleDeployCarCvPageList() {
        this.tableLoad = true;
        const res = await entruckInfoCvPageList(
          {
            rows: this.size,
            page: this.page,
            batchNumber: this.condition.batchNumber || '',
            waybillNo: this.condition.waybillNo || '',
            frameNumber: this.condition.frameNumber || '',
            brandName: this.condition.brandName || '',
            modelName: this.condition.modelName || '',
            taskToolName: this.condition.taskToolName || '',
            taskToolNum: this.condition.taskToolNum || '',
            taskPeople: this.condition.taskPeople || '',
            startDate: this.condition.startTime || '',
            endDate: this.condition.endTime || '',
            // startDate: this.condition.time[0]?this.condition.time[0]:'',
            // endDate: this.condition.time[1]?this.condition.time[1]:'',
          },
        );
        this.tableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        this.TableDatas = res.data.records;
        this.total = res.data.total;
      },
      // 结束时间
      dateChange(val) {
        if (this.condition.endTime && this.condition.startTime && (this.condition.endTime <= this.condition.startTime)) {
          if (val == this.condition.endTime) this.condition.endTime = '';
          if (val == this.condition.startTime) this.condition.startTime = '';
          return this.$message.warning('结束日期必须大于开始日期！');
        }
      },
      contractSizeChange(sizes) {
        this.size = sizes;
        this._vehicleDeployCarCvPageList();
      },
      async addBtn() {
        this.teamData = {
          selection: [],
          type: '',
        };
        this.dialogVisible = true;
      },
      contractCurrentChange(page) {
        this.page = page;
        this._vehicleDeployCarCvPageList();
      },
      async positionChange(type) {
        this.teamData.position = '';
        if (type === 1) {
          let consignorRes = await vehiclePublicSelectWarehouse();
          if (consignorRes.status !== 0) return this.$message.error(consignorRes.message);
          this.positionOption = consignorRes.data;
          this.positionOption.forEach((item, index) => {
            this.positionOption[index].warehouseList = item.warehouseList.map((item) => {
              this.consignorMap.set(item.id, item);
              return {
                id: item.id,
                customerName: item.addr,
              };
            });
          });
          return;
        } else if (type === 2) {
          let portRes = await supplierPublicSelectPort();
          if (portRes.status !== 0) return this.$message.error(portRes.message);
          this.positionOption = portRes.data;
          return;
        }
        const res = await supplierPublicSelectDistributor();
        if (res.status !== 0) return this.$message.error(res.message);
        this.positionOption = res.data;
      },

      // 下载模板
      downLoad() {
        window.location.href = '/file/批量装车模板.xlsx';
      },
      /**
       * 导入成功
       * @param data 分页更新数据
       */
      // 批量导入
      planOnSuccess(res) {
        this.importLoading = false;
        // if (res.status !== 0) return this.$message.error(res.message);
        // this.$message.success(res.message);
        this.$alert(res.message, '提示', {
          confirmButtonText: '关闭',
          callback: async () => {
            this.TableDatas = res.data;
            await this._vehicleDeployCarCvPageList();
          },
        });
        // this.TableDatas = res.data;
        // this._vehicleDeployCarCvPageList();
      },
      beforeUpload(file) {
        let len = file.name.split('.').length;
        if (file.name.split('.')[len - 1] == 'xls' || file.name.split('.')[len - 1] == 'xlsx') {
          this.uploadData.file = file.name;
          this.importLoading = true;
        } else {
          this.$message.error('请选择excel文件导入！！！');
          return false;
        }
      },

      // 根据区域获取港口
      async _getSelectPort(id) {
        let port = await getSelectPort(id);
        if (port.status !== 0) return this.$message.error(port.message);
        this.startPortList = port.data;
        this.teamData.startPort = '';
      },
      // 供应商改变
      async carChange(value) {
        let {
          position,
          startPort,
        } = this.teamData;
        // 根据供应商获取交车地
        const res = await getTruckCarBySupplier({
          // positionType:type,
          // positionId:type ===1? position[1]:position.id,
          positionId: position[position.length - 1],
          supplierId: value,
          portId: startPort,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        // 交车地数组赋值
        this.taskList = [];
        if (res.data.length > 0) {
          res.data.forEach(item => {
            if (item.delivery_type == 1) {
              if (item.delivery_name.delivery_port_name) {
                item.delivery_name = item.delivery_name + '【' + item.delivery_port_name + '】';
              }
            }
            this.taskList.push(item);
          });
        }
        // 清空交车地
        if (this.teamData.task && this.teamData.task != '') {
          this.teamData.task = '';
          this.$refs['ruleForm'].clearValidate();
        }
        // 清空运输车
        if (this.teamData.shippers && this.teamData.shippers != '') {
          this.teamData.shippers = '';
          this.$refs['ruleForm'].clearValidate();
        }
        // 清空委托车
        this.teamData.table = [];
        this.entrustedTable.page = 1;
        this.entrustedTable.total = 0;
      },
      // 交车地改变
      async taskChange(val) {
        let {
          position,
          startPort,
          task,
        } = this.teamData;
        // 给运输车数组赋值
        this.shippersOption = [];
        if (val.driverList && val.driverList.length && val.driverList.length > 0) {
          this.shippersOption = val.driverList;
        }
        // 清空运输车
        if (this.teamData.shippers && this.teamData.shippers != '') {
          this.teamData.shippers = '';
          this.$refs['ruleForm'].clearValidate();
        }
        // 清空委托车
        this.teamData.table = [];
        this.entrustedTable.page = 1;
        this.entrustedTable.total = 0;

        //查询委托车
        // let entrustRes = await selectCarByPosition({
        //   basicId:task.id
        // })
        // if (entrustRes.status !==0) return this.$message.error(entrustRes.message);
        // this.$set(this.teamData,'table',[]);
        // this.$set(this.teamData,'table',entrustRes.data.map(item=>{
        //   return {
        //     ...item,
        //     option:[],
        //   }
        // }))
        this.carSearchBtn();
        // this.$nextTick(()=>{
        // 只有使用表格原数据，才会生效   从表格原数据中赛选
        // this.$refs.entrustTableRef.toggleRowSelection(this.teamData.table.find((item)=>{
        //   return item.supplier_id !==null
        // }));
        // })
        console.log(this.teamData.selection);
      },
      // 运输车改变
      async entrustChange() {
        // const res = await getTruckCarBySupplier(this.teamData.shippers.id);
        // if(res.status !== 0) this.$message.error(res.message);
        // const res2 = await getInfoByDriverId(this.teamData.shippers.driverId);
        // if(res2.status !== 0) this.$message.error(res2.message);
        //
        // this.teamData={
        //   ...this.teamData,
        //   name:res2.data.name,
        //   tell:res2.data.account,
        //   table:res.data,
        // }
      },
      // 装车地改变
      async handleChange(value) {
        console.log(value);
        this._getSelectPort(value[value.length - 1]);
        // 清空供应商和运输车
        if (this.teamData.entrust && this.teamData.entrust != '') {
          this.teamData.entrust = '';
          this.$refs.ruleForm.clearValidate(['entrust']);
        }
        if (this.teamData.shippers && this.teamData.shippers != '') {
          this.teamData.shippers = '';
          this.$refs.ruleForm.clearValidate(['shippers']);
        }
        // 清空交车地
        if (this.teamData.task && this.teamData.task != '') {
          this.teamData.task = '';
          this.$refs['ruleForm'].clearValidate();
        }
        // 清空委托车
        this.teamData.table = [];
        this.entrustedTable.page = 1;
        this.entrustedTable.total = 0;

        let { type } = this.teamData;
        const res = await vehicleGetSupplierByAppointPosition({ positionId: value[value.length - 1] });
        if (res.status !== 0) return this.$message.error(res.message);
        this.entrustOption = res.data;

        // const entrustRes = await vehiclGetChildByPosition({positionId:value[1],positionType:type});
        // if (entrustRes.status !== 0) return this.$message.error(entrustRes.message);
        // this.$set(this.teamData,'table',entrustRes.data.map(item=>{
        //   return {
        //     ...item,
        //     option:[],
        //   }
        // }))
      },
      // 装车港口改变
      async portChange(val) {
        this.$set(this.teamData, this.teamData.startPort, val);
        this.$forceUpdate();
        // 清空供应商和运输车
        if (this.teamData.entrust && this.teamData.entrust != '') {
          this.teamData.entrust = '';
          this.$refs.ruleForm.clearValidate(['entrust']);
        }
        if (this.teamData.shippers && this.teamData.shippers != '') {
          this.teamData.shippers = '';
          this.$refs.ruleForm.clearValidate(['shippers']);
        }
        // 清空交车地
        if (this.teamData.task && this.teamData.task != '') {
          this.teamData.task = '';
          this.$refs['ruleForm'].clearValidate();
        }
        // 清空委托车
        this.teamData.table = [];
        this.entrustedTable.page = 1;
        this.entrustedTable.total = 0;

        const res = await vehicleGetSupplierByAppointPosition({
          positionId: this.teamData.position[this.teamData.position.length - 1],
          portId: val,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.entrustOption = res.data;
      },

      // 新增 装车车辆 一级 —— 查询
      async carSearchBtn() {
        //   batchNumber:'',
        //   waybillNo:'',
        //   frameNumber:'',
        //   brand:'',
        // },
        let obj = {
          type: 0,
          departurePlaceId: this.teamData.position[this.teamData.position.length - 1],
          departurePortId: this.teamData.startPort || '',
          supplierId: this.teamData.entrust,
          page: this.entrustedTable.page,
          rows: this.entrustedTable.size,
        };
        this.carTableLoad = true;
        const res = await loadingPageList(obj);
        this.carTableLoad = false;
        if (res.status !== 0) return this.$message.error(res.message);
        // 给数据加上 index和children
        if (res.data.records.length > 0) {
          res.data.records.forEach((item, index) => {
            item.index = index;
            item.loading = true;
            item.children = [];
          });
        }
        this.teamData.table = res.data.records;
        this.entrustedTable.total = res.data.total;
      },
      // 新增 装车车辆 二级 —— 查询
      async carSearchChildBtn(row) {
        let obj = {
          type: 0,
          departurePlaceId: this.teamData.position[this.teamData.position.length - 1],
          departurePortId: this.teamData.startPort,
          supplierId: this.teamData.entrust,
          batchNumber: row.batch_number,
          waybillNo: row.waybill_no,
        };
        const res = await loadingChildPageList(obj);
        if (res.status !== 0) return this.$message.error(res.message);
        this.teamData.table[row.index].children = res.data;
      },
      // 切换每页数据条数
      conditionSizeChange(sizes) {
        this.entrustedTable.size = sizes;
        this.carSearchBtn();
      },
      // 新增 装车车辆 —— 换页
      conditionCurrentChange(page) {
        this.entrustedTable.page = page;
        this.carSearchBtn();
      },
      // 新增 装车车辆 —— 重置
      carResetBtn() {
        this.entrustedTable.batchNumber = '';
        this.entrustedTable.waybillNo = '';
      },
      // 展开行时是否查询 装车车辆 二级
      async judgeFn(row) {
        if (this.teamData.table[row.index].children.length <= 0) {
          // this.carSearchChildBtn(row);
          let obj = {
            type: 0,
            departurePlaceId: this.teamData.position[this.teamData.position.length - 1],
            departurePortId: this.teamData.startPort,
            supplierId: this.teamData.entrust,
            batchNumber: row.batch_number,
            waybillNo: row.waybill_no,
          };
          const res = await loadingChildPageList(obj);
          if (res.status !== 0) return this.$message.error(res.message);
          this.teamData.table[row.index].children = res.data;
        }
        return Promise.resolve;
      },
      // 新增 装车车辆 —— 批次号 展开行
      expandChange(row, val) {
        const isExpend = val.some(r => r.index === row.index);
        if (isExpend && val.length > 0) {
          this.teamData.table[row.index].loading = true;
          // 新增 装车车辆 二级 —— 查询
          // if(this.teamData.table[row.index].children.length <= 0){
          //   this.carSearchChildBtn(row);
          // }
          Promise.all([this.judgeFn(row)])
            .then(() => {
              if (this.selectData.length > 0) {
                let flg = false;
                this.selectData.forEach(item => {
                  if (item.id == row.batch_number + row.waybill_no) {
                    if (item.list.length > 0) {
                      item.list.forEach(tem => {
                        this.$nextTick(() => {
                          this.$refs[row.batch_number + row.waybill_no].toggleRowSelection(
                            this.teamData.table[row.index].children.find(tem1 => {
                              return tem.id == tem1.id;
                            })
                            , true);
                        });
                      });
                    }
                    return flg = true;
                  }
                });
                if (!flg) {
                  this.selectData.push({
                    id: row.batch_number + row.waybill_no,
                    list: [],
                  });
                }
              } else {
                this.selectData.push({
                  id: row.batch_number + row.waybill_no,
                  list: [],
                });
              }
              this.teamData.table[row.index].loading = false;
            });
        }
      },
      // 新增 装车车辆 —— 批次号 多选框
      handleCurrentChange(val, index) {
        if (val.length > 0) {
          this.selectData.filter(item => {
            if (item.id == val[0].batch_number + val[0].waybill_no) {
              item.list = val;
            }
          });
        }
      },

      async carChange2(value) {
        console.log(value, 'value');
        let { type } = this.teamData;
        let res = await vehicleGetSupplierByAppointPosition({
          positionType: type,
          positionId: value.id,
        });
        if (res.status !== 0) return this.$message.error(res.message);
        this.entrustOption = res.data;
        // const entrustRes = await vehiclGetChildByPosition({positionId:value.id,positionType:type});
        // if (entrustRes.status !== 0) return this.$message.error(entrustRes.message);
        // this.$set(this.teamData,'table',entrustRes.data.map(item=>{
        //   return {
        //     ...item,
        //     option:[],
        //   }
        // }))

      },
      handleSelectionChange(val) {
        this.teamData.selection = val.filter(item => {
          return item !== undefined;
        });
      },
      saveClick() {
        this.$refs.ruleForm.validate(async valid => {
          if (valid) {
            this.teamData.selection = [];
            this.selectData.forEach(item => {
              this.teamData.selection = this.teamData.selection.concat(item.list);
            });
            if (this.teamData.selection.length === 0) return this.$message.warning('请至少选择一个委托车！');
            let { shippers } = this.teamData;
            const obj = {
              taskToolId: shippers.truck_id,
              taskToolUid: shippers.driver_id,
              portId: shippers.startPort,
              carList: this.teamData.selection.map(item => {
                return {
                  id: item.id,
                };
              }),
            };
            this.teamDataLoad = true;
            const res = await vehiclAddScanOperation(obj);
            if (res.status !== 0) {
              this.teamDataLoad = false;
              return this.$message.error(res.message);
            }
            this.$message.success(res.message);
            this.dialogVisible = false;
            this.teamDataLoad = false;
            await this._vehicleDeployCarCvPageList();
          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$refs.ruleForm.resetFields();
      },
      searchBtn() {
        this.page = 1;
        this._vehicleDeployCarCvPageList();
      },
      resetBtn() {
        this.condition = {
          batchNumber: '',   // 批次号
          waybillNo: '',    // 运单号
          frameNumber: '',    // 车架号
          brandName: '',    // 品牌
          modelName: '',    // 型号
          taskToolName: '',   // 司机姓名
          taskToolNum: '',    // 车牌号
          taskPeople: '',   // 扫码人
          // time: '',   // 开始/结束时间
          startTime: '',
          endTime: '',
        };
      },
      exportClick() {
        if (!this.condition.startTime || !this.condition.endTime || this.condition.startTime == '' || this.condition.endTime == '') {
          return this.$message.warning('请选择开始日期和结束日期！');
        }
        window.exportExcelAllFunc({
          type: 'post',
          url: '/transportScanOperation/export',
          obj: {
            batchNumber: this.condition.batchNumber,
            waybillNo: this.condition.waybillNo,
            frameNumber: this.condition.frameNumber,
            taskType: 1,
            brandName: this.condition.brandName,
            modelName: this.condition.modelName,
            taskToolName: this.condition.taskToolName,
            taskToolNum: this.condition.taskToolNum,
            taskPeople: this.condition.taskPeople,
            startDate: this.condition.startTime ? this.condition.startTime : '',
            endDate: this.condition.endTime ? this.condition.endTime : ''
          },
          name: '扫码装车表'
        })
        // let token = getSessionStore('token');
        // let url = baseUrl + '/platform/transportScanOperation/export';
        // url += '?batchNumber=' + this.condition.batchNumber + '&waybillNo=' + this.condition.waybillNo;
        // url += '&frameNumber=' + this.condition.frameNumber + '&taskType=1';
        // url += '&brandName=' + this.condition.brandName + '&modelName=' + this.condition.modelName;
        // url += '&taskToolName=' + this.condition.taskToolName + '&taskToolNum=' + this.condition.taskToolNum;
        // url += '&taskPeople=' + this.condition.taskPeople + '&startDate=' + (this.condition.startTime ? this.condition.startTime : '');
        // url += '&endDate=' + (this.condition.endTime ? this.condition.endTime : '');
        // url += '&access_token=' + token;
        // window.location.href = url;
        // window.exportExcelGet('/platform/transportScanOperation/export',
        //   'batchNumber=' + this.condition.batchNumber + '&waybillNo=' + this.condition.waybillNo +
        //   '&frameNumber=' + this.condition.frameNumber + '&taskType=1' +
        //   '&brandName=' + this.condition.brandName + '&modelName=' + this.condition.modelName +
        //   '&taskToolName=' + this.condition.taskToolName + '&taskToolNum=' + this.condition.taskToolNum +
        //   '&taskPeople=' + this.condition.taskPeople + '&startDate=' + (this.condition.startTime ? this.condition.startTime : '') +
        //   '&endDate=' + (this.condition.endTime ? this.condition.endTime : '')
        // );
      },
      failureClick(id) {
        this.$confirm('确定装车失败吗？确认后，该委托车将回到上级中！', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const res = await cancel(id);
            if (res.status !== 0) return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._vehicleDeployCarCvPageList();
          })
          .catch(() => {
          });
      },
      searchCopyFormat(value, flag) {
        let splitArr = value.clipboardData.getData('Text')
          .replace(/\s/g, ',')
          .split(',');
        splitArr = splitArr.filter(item => item);
        splitArr = splitArr[splitArr.length - 1] === '' ? splitArr.slice(0, splitArr.length - 1) : splitArr;
        switch (flag) {
          case 'frameNumber':
            this.condition.frameNumber = splitArr.length > 1 ? splitArr.join(',') : splitArr[0];
            break;
        }
      },

    },
  };
</script>

<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 25px;
    background-color: #fff;

    .line {
      width: 12px;
      height: 32px;
      background-color: rgba(51, 84, 131, 100);
      margin-right: 10px;
    }

    .line + span {
      font-size: 16px;
      color: rgba(51, 84, 131, 100);
      font-weight: 600;
    }

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Container {
        width: 200px;
        display: flex;
        align-items: center;
        margin-right: 5px;
        margin-bottom: 5px;

        p {
          font-size: 14px;
          color: rgba(16, 16, 16, 100);
        }
      }

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }

      .navContainer p {
        display: inline-block;
        text-align: right;
        width: 70px;
      }

      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }

    .content {
      display: flex;
      flex-direction: column;
      align-items: center;

      .tableContainerNav {
        font-size: 16px;
        text-decoration: none;
      }

      .tableContainer {
        margin-top: 10px;
        margin-bottom: 25px;
        width: 100%;

        &Nav {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;

          span {
            color: rgba(51, 136, 255, 1);
            text-decoration: underline;
            margin-right: 10px;

            &:hover {
              cursor: pointer;
            }
          }
        }

        ::v-deep {
          .el-table .cell {
            padding: 0;
          }

          .el-table th {
            padding: 0;
          }

          .el-table td {
            padding: 0;
          }
        }
      }

      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-bottom: 20px;

        span {
          font-size: 13px;
        }
      }
    }

    .detail {
      width: 100%;
      padding: 10px 0 20px 20px;

      .baseInfo {
        display: flex;
        flex-direction: column;

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 20px 23px 0 23px;

          &Item {
            margin-bottom: 20px;

            .addressItem {
              font-size: 12px;
              color: rgba(153, 153, 153, 1);
              margin-bottom: 10px;
              margin-left: 70px;
            }

            span {
              color: rgba(16, 16, 16, 100);
              font-size: 14px;
            }

            .specialOne {
              width: 50%;
            }
          }

          .specialItem {
            display: flex;
          }
        }
      }

      .operation {
        display: flex;
        flex-direction: column;

        ::v-deep {
          .el-table td, .el-table th {
            padding: 0;
          }

          .cell {
            font-size: 10px;
            padding: 0;
          }
        }

        &Title {
          display: flex;
          align-items: flex-end;

          p {
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }

        &Table {
          width: 100%;
          margin-top: 10px;
          padding: 0 20px;
        }
      }
    }

    ::v-deep {
      .el-table th > .cell {
        font-weight: 700 !important;
      }
    }
  }

  .company {
    width: 100%;
    padding: 20px 10px 10px 10px;
    max-height: 70vh;
    overflow-y: auto;

    .transport {
      width: 100%;
      position: relative;
      padding: 0 10px;
      margin-bottom: 20px;

      &Title {
        margin-bottom: 0;
        position: absolute;
        top: -21px;
        z-index: 999;
        background-color: #fff;
        left: 20px;
        padding-right: 10px;
        color: rgb(51, 84, 131);
        font-size: 15px;
        font-weight: 700;

        ::v-deep {
          .el-form-item__label {
            color: rgb(51, 84, 131);
            font-size: 15px;
          }
        }
      }
    }

    .productTable {
      margin-top: 15px;

      &Nav {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        &Left {
          display: flex;
          align-items: center;

          ::v-deep {
            .el-input--mini .el-input__inner {
              height: 22px;
            }

            .el-input__icon {
              height: 120%;
            }
          }

          span {
            color: #606266;
            font-weight: 700
          }
        }

        &Right {
          text-decoration: underline;
          color: rgb(51, 136, 255);
        }
      }

      ::v-deep {
        .el-checkbox {
          margin-left: 8px;
        }

        .el-input--mini .el-input__inner {
          width: 100%;
        }

        .cell {
          font-size: 10px;
          padding: 0;
        }

        .el-table td, .el-table th {
          padding: 0;
        }
      }

      .tableAddBtnContainer {
        border: 1px solid #EBEEF5;;
        border-top-style: none;
        width: 100%;
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 15px;

        .AddContainer {
          display: flex;
          align-items: center;

          &:hover {
            cursor: pointer;
          }
        }

        img {
          object-fit: cover;
          margin-right: 5px;
        }

        p {
          font-size: 13px;
          color: #F59A23;
          font-family: 'Arial Normal', 'Arial', sans-serif;
        }
      }
    }

    .update {
      font-size: 14px;
      color: rgba(51, 136, 255, 1);
      text-decoration: underline;
    }

    ::v-deep {
      .el-form-item__label {
        font-weight: 700;
      }

      .el-form-item__label {
        padding: 0;
      }

      .el-form-item {
        margin-bottom: 12px;
      }

      .el-form-item__content {
        position: relative;
      }

      .el-checkbox {
        margin-left: 0;
      }

      .cell {
        font-size: 10px;
        padding: 0;
      }

      .el-table td, .el-table th {
        padding: 0;
      }
    }

    .btnContainer {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 20px 0 5px 0;

      button {
        margin: 0 15px;
      }
    }
  }

  ::v-deep {
    .el-date-editor .el-range-separator {
      padding: 0px;
    }

    .el-table .ui-warning-row {
      background: #DDD !important;
    }

    .el-table .ui-warning-row .cell {
      color: red;
    }

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
    }

    .transport {
      padding-top: 20px !important;
    }
  }

  .form-item-span {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 80%;
    margin-left: 10%;
    margin-bottom: 10px;

    span {
      color: #606266;
      font-weight: 700
    }
  }

  .paginationContainer {
    margin-right: auto;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
  }

  .require::before {
    content: '•';
    color: red;
  }
</style>
